(function () {
  var TURNSTILE_SCRIPT_URL =
    "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  var TURNSTILE_ACTION = "public_course_registration";
  var turnstileScriptPromise;

  function ready(callback) {
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  function loadTurnstileScript() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstileScriptPromise) return turnstileScriptPromise;

    turnstileScriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-isave-turnstile="true"]');
      if (existing) {
        existing.addEventListener("load", function () {
          resolve(window.turnstile);
        });
        existing.addEventListener("error", reject);
        return;
      }

      var script = document.createElement("script");
      script.src = TURNSTILE_SCRIPT_URL;
      script.async = true;
      script.defer = true;
      script.dataset.isaveTurnstile = "true";
      script.addEventListener("load", function () {
        resolve(window.turnstile);
      });
      script.addEventListener("error", reject);
      document.head.appendChild(script);
    });

    return turnstileScriptPromise;
  }

  function addHoneypot(form) {
    var honeypot = document.createElement("input");
    honeypot.type = "text";
    honeypot.name = "website";
    honeypot.autocomplete = "off";
    honeypot.tabIndex = -1;
    honeypot.setAttribute("aria-hidden", "true");
    honeypot.style.position = "absolute";
    honeypot.style.left = "-10000px";
    honeypot.style.width = "1px";
    honeypot.style.height = "1px";
    honeypot.style.opacity = "0";
    form.appendChild(honeypot);
    return honeypot;
  }

  function protectionConfigUrl(form) {
    return form.action + (form.action.indexOf("?") === -1 ? "?" : "&") + "protection=config";
  }

  ready(function () {
    document.querySelectorAll("[data-isave-landing]").forEach(function (root) {
      var modal = root.querySelector("[data-isave-modal]");
      var form = root.querySelector("[data-isave-form]");
      var error = root.querySelector("[data-isave-error]");
      var submit = root.querySelector("[data-isave-submit]");
      if (!modal || !form) return;

      var honeypot = addHoneypot(form);
      var startedAt = null;
      var widgetId = null;
      var turnstileToken = "";
      var tokenResolve = null;
      var tokenReject = null;
      var tokenTimeout = null;
      var widgetPromise = null;

      var widgetContainer = document.createElement("div");
      widgetContainer.className = "isave-turnstile";
      widgetContainer.setAttribute("aria-live", "polite");
      form.insertBefore(widgetContainer, error || submit);

      function showError(message) {
        if (!error) return;
        error.textContent = message;
        error.classList.add("is-visible");
      }

      function clearError() {
        if (!error) return;
        error.textContent = "";
        error.classList.remove("is-visible");
      }

      function resetSubmit() {
        if (!submit) return;
        submit.disabled = false;
        submit.textContent = submit.dataset.originalText || "Pradėti mini kursą";
      }

      function resetTurnstile() {
        turnstileToken = "";
        if (tokenTimeout) window.clearTimeout(tokenTimeout);
        tokenTimeout = null;
        tokenResolve = null;
        tokenReject = null;
        if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
      }

      async function prepareTurnstile() {
        if (widgetPromise) return widgetPromise;

        widgetPromise = Promise.all([
          loadTurnstileScript(),
          fetch(protectionConfigUrl(form), { headers: { Accept: "application/json" } }).then(
            function (response) {
              if (!response.ok) throw new Error("Apsauga laikinai nepasiekiama.");
              return response.json();
            }
          ),
        ]).then(function (results) {
          var turnstile = results[0];
          var config = results[1];
          if (!turnstile || !config.turnstileSiteKey) {
            throw new Error("Apsauga laikinai nepasiekiama.");
          }

          widgetId = turnstile.render(widgetContainer, {
            sitekey: config.turnstileSiteKey,
            action: TURNSTILE_ACTION,
            appearance: "interaction-only",
            execution: "execute",
            theme: "auto",
            size: "flexible",
            callback: function (token) {
              turnstileToken = token;
              if (tokenTimeout) window.clearTimeout(tokenTimeout);
              if (tokenResolve) tokenResolve(token);
              tokenResolve = null;
              tokenReject = null;
            },
            "expired-callback": function () {
              resetTurnstile();
            },
            "error-callback": function () {
              if (tokenReject) tokenReject(new Error("Nepavyko patvirtinti apsaugos."));
              resetTurnstile();
            },
          });

          return widgetId;
        });

        return widgetPromise;
      }

      async function getTurnstileToken() {
        await prepareTurnstile();
        if (turnstileToken) return turnstileToken;

        return new Promise(function (resolve, reject) {
          tokenResolve = resolve;
          tokenReject = reject;
          tokenTimeout = window.setTimeout(function () {
            tokenResolve = null;
            tokenReject = null;
            reject(new Error("Apsaugos patvirtinimas užtruko. Bandykite dar kartą."));
          }, 12_000);
          window.turnstile.execute(widgetId);
        });
      }

      function openModal() {
        startedAt = Date.now();
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        var firstInput = modal.querySelector('input:not([name="website"])');
        if (firstInput) firstInput.focus();
        prepareTurnstile().catch(function () {
          showError("Registracijos apsauga laikinai nepasiekiama. Atnaujinkite puslapį.");
        });
      }

      function closeModal() {
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
      }

      root.querySelectorAll("[data-isave-open-modal]").forEach(function (button) {
        button.addEventListener("click", function (event) {
          event.preventDefault();
          openModal();
        });
      });
      root.querySelectorAll("[data-isave-close-modal]").forEach(function (button) {
        button.addEventListener("click", closeModal);
      });
      modal.addEventListener("click", function (event) {
        if (event.target === modal) closeModal();
      });
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && modal.classList.contains("is-open")) closeModal();
      });

      form.addEventListener("submit", async function (event) {
        event.preventDefault();
        clearError();
        if (submit) {
          submit.disabled = true;
          submit.dataset.originalText = submit.dataset.originalText || submit.textContent;
          submit.textContent = "Tikrinama ir registruojama...";
        }

        try {
          var token = await getTurnstileToken();
          var formData = new FormData(form);
          var payload = {
            courseId: formData.get("courseId") || undefined,
            courseSlug: formData.get("courseSlug") || undefined,
            firstName: formData.get("firstName"),
            lastName: formData.get("lastName"),
            email: formData.get("email"),
            website: honeypot.value,
            startedAt: startedAt,
            turnstileToken: token,
          };
          var response = await fetch(form.action, {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify(payload),
          });
          var data = await response.json();
          if (!response.ok || !data.success || !data.redirectUrl) {
            throw new Error(data.error || "Registracija nepavyko. Bandykite dar kartą.");
          }
          window.location.href = data.redirectUrl;
        } catch (registrationError) {
          showError(
            registrationError.message || "Registracija nepavyko. Bandykite dar kartą."
          );
          resetTurnstile();
          resetSubmit();
        }
      });
    });
  });
})();
